import { render, staticRenderFns } from "./moulddata.vue?vue&type=template&id=a704bce0"
import script from "./moulddata.vue?vue&type=script&lang=js"
export * from "./moulddata.vue?vue&type=script&lang=js"
import style0 from "./moulddata.vue?vue&type=style&index=0&id=a704bce0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports